import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@/modules/common/components/Paper';
import Error from '@/modules/common/components/Error';
import Content from '@/modules/common/components/Content';
import ContentBody from '@/modules/common/components/ContentBody';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, error: ''};
    }

    // noinspection JSUnusedLocalSymbols
    componentDidUpdate(prevProps, prevState, snapshot) {
        try {
            // noinspection JSUnresolvedVariable
            if (prevProps.location.pathname !== this.props.location.pathname) {
                this.setState({hasError: false, error: ''});
            }
        }
        catch (error) {

        }
    }

    static getDerivedStateFromError(error) {
        return {hasError: true, error: error.toString()};
    }
    render() {
        if (this.state.hasError) {
            return (
                <Content><ContentBody><Paper>
                    <Error>
                        <Typography>{this.state.error}</Typography>
                    </Error>
                </Paper></ContentBody></Content>
            );
        }
        else {
            return this.props.children;
        }
    }
}

export default ErrorBoundary;
